export enum NotificationTypeEnum {
    ERROR = "error",
    INFO = "info",
    WARNING = "warning",
    SUCCESS = "success",
}
